import React, { useState } from "react";
import { NotificationManager } from "react-notifications";

function ScrollToDiv() {

  const [signatureDone, setSignatureDone] = useState(true)
  const scroll = () => {
    let signDiv = document.querySelectorAll(".notsign");
    if (signDiv.length) {
      signDiv[0].parentNode.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
      signDiv[0].style =
        "box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px; width:100%; height:100%; display: none";
    } else {
      NotificationManager.success("סיימתם לחתום על המסמך, לחצו על שמור כדי לשלוח אותו אלינו");
      setSignatureDone(!signatureDone)
    }
  };
  return (
    <>
      {signatureDone ? (
        <div className="scroll-div d-flex jc-center ai-center" onClick={scroll}>
          <button className="nextbutton py-10 px-extra fs-18">הבא</button>
        </div>
      ) : null}
    </>
  );
}

export default ScrollToDiv;
